import { Colors, Fonts, Images } from '../../../../shared/theme';
import commonStyle from '../../../../shared/theme/common-style';
import metrics from '../../../../shared/theme/metrics';

export default {
  defaultLayout: {
    flexDirection: 'column',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    minWidth: '1024px',
    backgroundColor: Colors.outWhite
  } as React.CSSProperties,
  landingLayout: {
    flexDirection: 'column',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    minWidth: '1024px',
    backgroundImage: `url(${Images.bg})`,
    backgroundPosition: 'bottom',
    backgroundSize: 'cover',
  } as React.CSSProperties,
  defaultHeader: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: Colors.white,
    justifyContent: 'space-between'
  },
  landingHeader: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: Colors.white,
    boxShadow: 'rgba(0,0,0,0.1) 0px 2px 10px',
    justifyContent: 'space-between'
  },
  defaultContent: {
    padding: '40px 32px',
    width: '1024px',
    minHeight: '100vh',
    backgroundColor: '#f2f2f2'
  },
  landingContent: {
    width: '1024px',
    minHeight: '100vh',
  },
  menuBox: {
    flexDirection: 'row',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
  },
  menuItemBoxOn: {
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: metrics.baseMargin + 4,
    paddingLeft: metrics.baseMargin + 4,
    height: '80px',
    display: 'flex',
  },
  menuItemBoxOff: {
    backgroundColor: Colors.white,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: metrics.baseMargin + 4,
    paddingLeft: metrics.baseMargin + 4,
    height: '80px',
    display: 'flex',
  },
  boxLogout: {
    paddingRight: '20px',
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    width: '200px',
    ...commonStyle.paddingLeftSmall
  } as React.CSSProperties,
  menuSettingBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80px',
    backgroundColor: 'yellow',
    paddingRight: '60px',
    paddingLeft: '60px'
  },
  logo: {
    cursor: 'pointer',
    width: '79px',
    height: '30px',
    marginLeft: '20px',
    marginRight: '20px'
  },
  dropdownImage: {
    paddingLeft: metrics.baseMargin / 2,
    fontSize: Fonts.size.text14,
    color: Colors.lightPurple,
  },
  menuItemBoxLogout: {
    justifyContent: 'left',
    alignItems: 'left',
    display: 'flex'
  } as React.CSSProperties,
  logoAndButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  }
};
